'use strict';

import Isotope from 'isotope-layout';
import 'isotope-packery';
import imagesLoaded from 'imagesloaded';

const wSearch = {
    el: {
        body          : document.querySelector('.wSearch_body'),
        toggleBtn     : document.querySelectorAll('.wSearch_toggle'),
        filterTitles  : document.querySelectorAll('.wSearch_filter-title'),
    },
    iso: null,

    init: function(){
        wSearch.events();
        wSearch.initJobGrid();
    },

    initJobGrid: function() {
        const jobList = document.querySelector('.page-template-tpl-jobs .search__list');

        if (!jobList || !jobList.querySelector('.search__item')) {
            return;
        }

        wSearch.iso = new Isotope(jobList, {
            itemSelector: '.search__item',
            layoutMode: 'packery',
            stagger: 0,
            percentPosition: false,
        });

        imagesLoaded(jobList, function() {
            wSearch.iso.layout();
            jobList.classList.add('is-visible');
        });

        let resizeTimer = null;
        window.addEventListener('resize', function() {
            if (resizeTimer !== null) {
                clearTimeout(resizeTimer);
            }

            resizeTimer = setTimeout(function() {
                if (wSearch.iso) {
                    wSearch.iso.layout();
                }
            }, 100);
        });
    },

    events: function() {
        if(wSearch.el.toggleBtn) {
            wSearch.el.toggleBtn.forEach(e => {
                e.addEventListener('click', function() {
                    wSearch.toggleSearch(e);
                });
            });
        }

        if (wSearch.el.filterTitles) {
            wSearch.el.filterTitles.forEach(title => {
                title.addEventListener('click', function() {
                    wSearch.toggleFilterList(title);
                });
            });
        }
    },

    toggleSearch: function(e) {
        if(window.matchMedia("(max-width: 1099px)").matches) {
            let body = e.parentElement;
            body.classList.contains('opened') ? body.classList.remove('opened') : body.classList.add('opened');
        }
    },

    toggleFilterList: function(title) {
        const parent = title.parentElement;
        const list = parent.querySelector('.wSearch_filter-list');
        const allLists = document.querySelectorAll('.wSearch_filter-list');
        const allArrows = document.querySelectorAll('.wSearch_toggleBtn .arrow');
        const arrow = parent.querySelector('.wSearch_toggleBtn .arrow');

        allLists.forEach(l => {
            if (l !== list) {
                l.classList.remove('expanded');
                l.classList.add('collapsed');
            }
        });

        allArrows.forEach(a => a.classList.remove('rotated'));

        if (list.classList.contains('collapsed')) {
            list.classList.remove('collapsed');
            list.classList.add('expanded');
            if (arrow) {
                arrow.classList.add('rotated');
            }
        } else {
            list.classList.remove('expanded');
            list.classList.add('collapsed');
            if (arrow) {
                arrow.classList.remove('rotated');
            }
        }
    },
}

export default wSearch;



// WEBPACK FOOTER //
// ./src/scripts/components/widgetSearch.js